import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import pt from 'vuetify/es5/locale/pt'
import en from 'vuetify/es5/locale/en'
import i18n from '../i18n'
import brand from '@/core/brand'

Vue.use(Vuetify)

i18n.mergeLocaleMessage('pt', { $vuetify: { ...pt } })
i18n.mergeLocaleMessage('en', { $vuetify: { ...en } })

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary:   brand.primaryColor,
        secondary: brand.secondaryColor,
        accent:    '#6d7278',
        error:     '#FF5252',
        info:      '#2196F3',
        success:   '#29C353',
        warning:   '#FFC107',
      },
      dark: {
        primary: brand.primaryColor,
      },
    },
  },
})
